"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CARD_WIDTH = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
exports.CARD_WIDTH = 150;
var Card = function (_a) {
    var item = _a.item;
    return (react_1.default.createElement("a", { href: item.linkPath, className: "companyShow-ItemBox" },
        react_1.default.createElement("div", { className: "companyShow-ItemBox_InnerFlex" },
            react_1.default.createElement("div", { className: "companyShow-ItemBox_ImageWrapper" }, item.image
                ? (react_1.default.createElement("div", { className: "companyShow-ItemBox_ImageWrapperInner" },
                    react_1.default.createElement("img", { src: item.image.src, alt: item.image.alt, className: "lazyload" }))) : (react_1.default.createElement("div", { className: (0, classnames_1.default)("taxonomy", "thumb_wrapper", "hover_bg", "companyShow-ItemBox_NoImage", item.noImageClass) },
                react_1.default.createElement("i", { className: (0, classnames_1.default)("taxonomy", "thumb", "icon", item.noImageClass) })))),
            react_1.default.createElement("object", null,
                react_1.default.createElement("a", { href: item.itemPath, className: "companyShow-ItemBox_Link" }, "\u3053\u306E\u5546\u54C1\u3092\u6BD4\u8F03")),
            react_1.default.createElement("div", { className: "companyShow-ItemBox_ItemName" }, item.name))));
};
exports.default = Card;
